import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import clientmanagmentObj from "../../services/client-managment.service";
import BoLoader from "../../helpers/BoLoader";
import AddApiKeyModal from "./AddApiPin";
import { useSelector } from "react-redux";

const ApiPin = () => {
  const [apiKeys, setApiKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("add");
  const [selectedKey, setSelectedKey] = useState(null);
  const { user: currentUser } = useSelector((state) => state.auth);

  // fetch list of API keys
  const fetchApiKeys = async () => {
    setLoading(true);
    try {
    let superclientid=  currentUser.user.SuperClientId;
    let clientid=currentUser.user.ClientId;
      const resp = await clientmanagmentObj.getApiKeys(clientid,superclientid);
      if (resp?.data?.payload) {
        setApiKeys(resp.data.payload);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApiKeys();
  }, []);

  const openModal = (mode, key) => {
    setAction(mode);
    setSelectedKey(key);
    setShowModal(true);
  };

  const handleSave = async (model) => {
    try {
      // build parameters
      const { clientId, apiKey, isIPActive, ipAddress, isAutoRenew } = model;
      const isDelete = action === "delete";

      await clientmanagmentObj.createApiKey(
        clientId,
        apiKey || "",
        isIPActive,
        ipAddress || "",
        isAutoRenew,
        isDelete
      );

      setShowModal(false);
      fetchApiKeys();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <BoLoader loading={loading} />
      <h3 className="mb-5">API Key Management</h3>

      {/* <div className="row mt-20">
        <div className="col-sm-6 col-md-3 col-xl-2" onClick={() => openModal("add", null)}>
          <div className="col-stats col-stats-action mb-40 col-stats-mbl">
            <div data-bs-toggle="modal">
              <span className="icon-load-card">
                <span className="path1" />
                <span className="path2" />
                <span className="path3" />
                <span className="path4" />
                <span className="path5" />
                <span className="path6" />
              </span>
              <br />
              <Link to="#" className="pt-3">
                Add API Key <span className="icon-bo-arrow" />
              </Link>
            </div>
          </div>
        </div>
      </div> */}

      {/* Table of API keys */}
      <div className="table-wrap">
        <table className="table table-borderless bo-table table-cards table-clients">
          <thead>
            <tr>
              <th>CLIENT</th>
              <th>API KEY</th>
              <th>IP RESTRICT</th>
              <th>ALLOWED IP</th>
              <th>AUTO RENEW</th>
              <th>LAST UPDATED</th>
              <th>EDIT</th>
            </tr>
          </thead>
          <tbody>
            {apiKeys.map(key => (
              <tr key={key.clientId}>
                <td title={key.clientName}>{key.clientName}</td>
                <td>{key.apiKey}</td>
                <td>{key.isIPActive ? "Yes" : "No"}</td>
                <td>{key.isIPActive ? key.ipAddress : "-"}</td>
                <td>{key.isIPActive ? (key.isAutoRenew ? "Yes" : "No") : "-"}</td>
                <td>{key.lastUpdated ? new Date(key.lastUpdated).toLocaleString() : "-"}</td>
                <td>
                  <span className="icon-show" onClick={() => openModal("update", key)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AddApiKeyModal
        show={showModal}
        onHide={() => setShowModal(false)}
        initialValues={
          action === "update" || action === "delete" ? selectedKey : {}
        }
        onSave={handleSave}
        action={action}
      />
    </div>
  );
};

export default ApiPin;
